module.exports = __webpack_public_path__ + "static/media/CreateGroup.88433a57.svg";